module.exports = __webpack_public_path__ + "img/geofisica_16-9.f0f2c149.jpg";